import React, { useContext,useEffect } from 'react';
import { useUserAPI } from '../../components/useUserAPI';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';
import { iAeonShowAeonPay } from '../../library/iaeon_sdk.js';
import { iAeonClose } from '../../library/iaeon_sdk.js';
import { iAeonShowMemberPay } from '../../library/iaeon_sdk.js';

import styles from '../../styles/Regi.module.scss';

// import useSound from 'use-sound';
// import se_08 from '../../sound/s08_se_delay0.mp3';

export function RegiSenyou(props) {

// const [se08_se] = useSound(se_08);

useEffect(() => {
	document.body.classList.remove('bg_white');
	// document.getElementById('header').classList.remove('is_fixed');
	document.getElementById('header').classList.add('is_behind');

	//高さ調整：arrows We 対応
	if(window.innerWidth >= 320){
		document.documentElement.style.zoom = window.innerWidth / 390;
		var zratio = window.innerWidth / 390;
	}else{
		document.documentElement.style.zoom = 1;
		var zratio = 1;
	}
	let hratio = window.innerHeight / (window.innerHeight * zratio);
	let realheight = window.innerHeight * hratio;
	let elementA = document.getElementById('regiFrame');
	if (elementA) {
		elementA.style.height = realheight + 'px';
	}
}, []);

const goRegiSenyouComp = () => {
	props.setPage("regi_senyou_comp");
	// se08_se();
}
const goRegiSelfComp = () => {
	props.setPage("regi_self_comp");
	// se08_se();
}
const goRegiYujin = () => {
	props.setPage("regi_yujin");
	// se08_se();
}
const goGateQRErr = () => {
	// props.setPage("error_gateqr")
}

//AEON Pay連携バージョン確認：5.1.0より小さい 連携なし（暫定版）、5.1.0以上 連携可能（連携版）
const { aeonPayVerCheck, updateAeonPayVerCheck } = useContext(SharedInfoContext);

//会員コード連携バージョン確認：false 5.4.0より小さい 連携なし（暫定版 STEP1）、true 5.4.0以上 連携可能（連携版 STEP2）
const { memberCodeVerCheck, updateMemberCodeVerCheck } = useContext(SharedInfoContext);

const goAEONPay = () => {
	console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
	console.log("REACT_APP_AEONPAY: " + process.env.REACT_APP_AEONPAY);
	if(process.env.REACT_APP_IAEON_FLG === "true" && process.env.REACT_APP_AEONPAY === "true"){ //AEONPAY有効
		// se08_se();
		props.setSoundState("se08_se");
		setTimeout(function(){
			if(sharedInfo.aeonPayVerCheck === true){
				//26.AeonPay画面表示API
				callAPI_26();
			}else {
				//22.クローズAPI（AEON Pay暫定対応
				callAPI_22();
			}
		}, 300);
	}
}

//26.AeonPay画面表示API
function callAPI_26(){
	let successCall_26 = function(success){
		var aaa = success;
		console.log('【iAeonShowAeonPay】success：' + aaa);
	}
	let errorCall_26 = function(error){
		var bbb = error;
		console.log('【iAeonShowAeonPay】error: ' + error.error_code + " : " + error.message);
		props.setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		props.setErr([true, error.error_code, error_msg]);
	}
	console.log("----------------------------");
	console.log('【iAeonShowAeonPay】call');
	iAeonShowAeonPay().then(successCall_26).catch(errorCall_26);
}

//22.クローズAPI（AEON Pay暫定対応
function callAPI_22(){
	let successCall_22 = function(success){
		// var aaa = JSON.stringify(success);
		var aaa = success;
		console.log('【iAeonClose】success：' + aaa);
		// $(".result_code_22").text('successCall：' + aaa);
		// $(".result_tit_22,.result_code_22").show();
	}
	let errorCall_22 = function(error){
		// var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonClose】error: ' + error.error_code + " : " + error.message);
		props.setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		props.setErr([true, error.error_code, error_msg]);
		// $(".result_code_22").text('errorCall：' + bbb);
		// $(".result_tit_22,.result_code_22").show();
	}
	iAeonClose().then(successCall_22).catch(errorCall_22);
	// iAeonClose({"page_name": "aeonpayBarcode"}).then(successCall_22).catch(errorCall_22);
}

const onSettleCheck = () => {
	console.log(`【settlecheckAPI】 決済完了 再び精算APIコール（タイマー発動）`);
	clearTimeout(stimer);
	clearTimeout(itimer);
	settlecheckAPI(props.shoppingStData.data.transactionno);
}


const { settlecheckAPI, data: settlecheckData, loading: settlecheckLoading, error: settlecheckError } = useUserAPI();

let stimer = null;
let itimer = null;

useEffect(() => {
	// if(itimer == null && sharedInfo.intervalFlg == true){
	if(itimer === null){
		console.log("runInterval: "+props.shoppingStData.data.runInterval);
		console.log("props.timeoutCountFlg:"+props.timeoutCountFlg);
		var sinterval = props.shoppingStData.data.runInterval * 1000;
		if(props.timeoutCountFlg === true){ //決済予約API・決済APIがタイムアウト・通信エラーのためタイマー省略
			itimer = "aaa";
			settlecheckAPI(props.shoppingStData.data.transactionno);
		}else{ //通常動作
			stimer = setTimeout(function(){
				console.log("transactionno："+props.shoppingStData.data.transactionno);
				// itimer = setInterval(function(){
				// 	settlecheckAPI(props.shoppingStData.data.transactionno);
				// }, sinterval);
				itimer = setTimeout(function(){
					settlecheckAPI(props.shoppingStData.data.transactionno);
				}, sinterval);
			// },props.shoppingStData.runInterval);
			// },60000);
			},10000);
		}
	// }else{
	// 	clearTimeout(stimer);
	// 	clearTimeout(itimer);
	}

	return () => {
		clearTimeout(stimer);
		clearTimeout(itimer);
	};
}, []);


useEffect(() => {

	if(settlecheckData){
		clearTimeout(stimer);
		clearTimeout(itimer);
		if (settlecheckData.data) { //SUCCESS
			console.log(`【settlecheckAPI】 status: ${settlecheckData.data.status}`);
			console.log(`【settlecheckAPI】 qrcode: ${settlecheckData.data.qrcode}`);
			console.log(`sharedInfo.exitGateQR: ${sharedInfo.exitGateQR}`);

			if(settlecheckData.data.status === 0){ //決済未完了 ERROR → エラー画面後に、商品登録画面へ
				console.log(`【settlecheckAPI】 決済未完了 ERROR`);
				props.setErrFlg(true);
				props.setErr([true, process.env.REACT_APP_ERROR_CODE_666, process.env.REACT_APP_ERROR_MESSAGE_666]);
				// props.setErr([true,`666`,`i1b0;お支払いが確認できませんでした;レジにてお支払いをお願いします。;;`]);
			}else if(settlecheckData.data.status === 1){ //決済完了 再び精算APIコール（タイマー発動）
				console.log(`【settlecheckAPI】 決済完了 再び精算APIコール（タイマー発動）`);
				var sinterval = props.shoppingStData.data.runInterval * 1000;
				itimer = setTimeout(function(){
					settlecheckAPI(props.shoppingStData.data.transactionno);
				}, sinterval);

			}else if(settlecheckData.data.status === 2){ //精算完了 支払い完了画面へ
				console.log(`【settlecheckAPI】 支払い完了画面へ`);
				console.log("【sharedInfo】 gateFlag:"+sharedInfo.gateFlag);
				if(sharedInfo.gateFlag === "1"){ //ゲート対象ON
					if(sharedInfo.exitGateQR === "999"){ //対人レジ用完了画面へ
						goRegiYujin();
					}else if(sharedInfo.exitGateQR === null){ //QR異常 ゲートQRエラー画面
						// goGateQRErr();
						goRegiSenyouComp();
					}else{ //正常
						// updateExitGateQR(settlecheckData.data.qrcode);
						goRegiSenyouComp();
					}
				}else{ //ゲート非対称OFF
					if(sharedInfo.exitGateQR === "999"){ //対人レジ用完了画面へ
						goRegiYujin();
					}else if(sharedInfo.exitGateQR === null){ //QR異常 ゲートQRエラー画面
						// goGateQRErr();
						goRegiSelfComp();
					}else{ //正常
						goRegiSelfComp();
					}
				}

			}else if(settlecheckData.data.status === 3){ //精算未完了 支払い完了画面へ
				console.log(`【settlecheckAPI】 支払い完了画面へ`);
				console.log("【sharedInfo】 gateFlag:"+sharedInfo.gateFlag);
				if(sharedInfo.gateFlag === "1"){ //ゲート対象ON
					if(sharedInfo.exitGateQR === "999"){ //対人レジ用完了画面へ
						goRegiSelfComp();
					}else if(sharedInfo.exitGateQR === null){ //QR異常 ゲートQRエラー画面
						// goGateQRErr();
						goRegiSenyouComp();
					}else{ //正常
						// updateExitGateQR(settlecheckData.data.qrcode);
						goRegiSenyouComp();
					}
				}else{ //ゲート非対称OFF
					if(sharedInfo.exitGateQR === "999"){ //対人レジ用完了画面へ
						goRegiYujin();
					}else if(sharedInfo.exitGateQR === null){ //QR異常 ゲートQRエラー画面
						// goGateQRErr();
						goRegiSelfComp();
					}else{ //正常
						goRegiSelfComp();
					}
				}
			}

		}else{ //ERROR
			console.log(`【settlecheckAPI】 errorCode: ${settlecheckData.errorCode}`);
			console.log(`【settlecheckAPI】 errorMessage: ${settlecheckData.errorMessage}`);
			console.log(`【settlecheckAPI】 isSuccess: ${settlecheckData.isSuccess}`);


			if(settlecheckData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${settlecheckData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${settlecheckData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(settlecheckData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${settlecheckData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${settlecheckData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else if(settlecheckData.errorCode === "32"){//フロントチェックエラー
				// props.setErrFlg(true);
				// props.setErr([true,`${settlecheckData.errorCode}`,`${settlecheckData.errorMessage}`]);
				props.setPage("error_32");
			}else{
				// props.setErrNum(`${settlecheckData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${settlecheckData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${settlecheckData.errorCode}`,`${settlecheckData.errorMessage}`]);
			}
		}
	}
	if(settlecheckError){
		console.log("settlecheckError");
		console.log(settlecheckError);
		// if(settlecheckError.errorCode === "35"){
			// props.setErrFlg(true);
			// props.setErr([true,`35`,`;通信エラー35;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
			if(props.timeoutCount >= 2){
				console.log("props.timeoutCount:");
				console.log(props.timeoutCount);
				props.setPage("error_35");
			}else{
				let tc = props.timeoutCount + 1;
				props.setTimeoutCount(tc);
				console.log("props.timeoutCount:");
				console.log(tc);

				var sinterval = props.shoppingStData.data.runInterval * 1000;
				itimer = setTimeout(function(){
					settlecheckAPI(props.shoppingStData.data.transactionno);
				}, sinterval);
			}
		// }else{
		// 	props.setErrFlg(true);
		// 	props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// }
	}
	if(settlecheckLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}

	return () => {
		clearTimeout(stimer);
		clearTimeout(itimer);
	};
}, [settlecheckData,settlecheckLoading,settlecheckError]);

const sharedInfo = useContext(SharedInfoContext);
const { exitGateQR, updateExitGateQR } = useContext(SharedInfoContext);
const { aeonPayFlg, updateAeonPayFlg } = useContext(SharedInfoContext);


useEffect(() => {

if(props.otbErrDispState === false){
	props.setOtbErrDispState(true);
	setTimeout(function(){
		if(process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false){ //会員バーコード連携 OTB取得失敗：STEP1 v5.4.0未満
			props.setErrFlg(true);
			props.setErr([true, "otb_error_step1", ""]);
		} else if(process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true){ //会員バーコード連携 OTB取得失敗：STEP2 v5.4.0以上
			props.setErrFlg(true);
			props.setErr([true, "otb_error_step2", ""]);
		}
	}, 400);
}

}, []);


//会員コードを表示
const goMemberCode = () => {
	// se08_se();
	props.setSoundState("se08_se");
	setTimeout(function(){
		if(sharedInfo.memberCodeVerCheck === true){ //v5.4.0以上
			//27.会員バーコード画面表示API
			callAPI_27();
		}else { //v5.4.0未満
			//22.クローズAPI（会員バーコード暫定対応
			callAPI_22();
		}
	}, 300);
}

//27.会員バーコード画面表示API
function callAPI_27(){
	let successCall_27 = function(success){
		var aaa = success;
		console.log('【iAeonShowMemberPay】success：' + aaa);
	}
	let errorCall_27 = function(error){
		console.log('【iAeonShowMemberPay】error: ' + error.error_code + " : " + error.message);
		props.setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		props.setErr([true, error.error_code, error_msg]);
	}
	console.log("----------------------------");
	console.log('【iAeonShowMemberPay】call');
	iAeonShowMemberPay().then(successCall_27).catch(errorCall_27);
}


return (
	<>
	<div id="regiFrame" className={styles.regiFrame}>
	<div className={styles.regiBox}>
		<div className={styles.regiBoxSpace02}></div>
		<div className={styles.regiBox_regiSenyou}>
			{
				(() => {
					if (props.otbErr !== true){
						if (props.shoppingData.data) { // SUCCESS
							return (
								<div className={styles.regiBox_codeRenkei_label}>
									<div className={`${styles.codeRenkei_circle} ${styles.is_active}`}>
										<span className={styles.codeRenkei_circle01}></span>
									</div>
									<span className={styles.regiBox_codeRenkei_label_txt}>iAEON会員コード認証済</span>
								</div>
							)
						}
					}
				})()
			}
			<p className={styles.regiBox_regiSenyou_tit}>レジ番号</p>
			<p className={styles.regiBox_regiSenyou_num}>{sharedInfo.signNumber}</p>
			<p className={styles.regiBox_regiSenyou_txt}>レジの表示を確認し<br/>お会計をしてください</p>
			<div className={styles.regiBox_info}>
				<p className={styles.regiBox_info_label}>点数</p>
				<p className={styles.regiBox_info_num}>
				{
					(() => {
						if (props.shoppingData) {
							if (props.shoppingData.data) { // SUCCESS
								return props.shoppingData.data.sumItemCount;
							} else { // ERROR
								return 0;
							}
						} else {
							return 0;
						}
					})()
				}
				</p>
				<p className={styles.regiBox_info_txt}>お支払い金額はレジにて<br/>ご確認ください</p>
			</div>
		</div>

		{/* <div className={styles.regiBox_regiSelf} onClick={goRegiSelfComp}>
			<div className={styles.regiBox_regiSelf_img}>
				<img src="/images/img_regi_self.svg" alt="" width="161" height="159"/>
			</div>
			<p className={styles.regiBox_regiSelf_txt}>レジの表示を確認し<br/>お会計をしてください</p>
			<div className={styles.regiBox_info}>
				<p className={styles.regiBox_info_label}>点数</p>
				<p className={styles.regiBox_info_num}>12</p>
				<p className={styles.regiBox_info_txt}>お支払い金額はレジにて<br/>ご確認ください</p>
			</div>
		</div> */}
	</div>

{
	(() => {
		console.log("REACT_APP_AEONPAY: " + process.env.REACT_APP_AEONPAY);
		if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "0"){ //AEONPAY有効＆連携OFF
			console.log("AEONPAY有効 ＆ 連携OFF");
			return (
				<div className={`${styles.aeonPayBox}`}>
					<p className={styles.aeonPayBox_txt}>
						<span>
							<span className={styles.aeonPayBox_txt_icn}>
								<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
							</span>
							{/* AEON Payで支払う */}
							AEON Payでお支払いの方はこちら
						</span>
					</p>
					<button className={`commonBtn commonBtn02 ${styles.aeonPayBtn}`} onClick={goAEONPay}><span>AEON Pay</span></button>
				</div>
			)
		}else if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "1" && props.otbErr === false){ //AEONPAY有効＆連携ON＆OTB取得成功
			console.log("AEONPAY有効 ＆ 連携ON ＆ OTB取得成功");
			return (
				<div className={`${styles.aeonPayBox} ${styles.aeonPayRenkei}`}>
					<p className={`${styles.aeonPayBox_txt} ${styles.aeonPayRenkei_txt}`}>
						<span>
							<span className={styles.aeonPayBox_txt_icn}>
								<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
							</span>
							AEON Payでのお支払いは<br/>レジ画面にて選択してください
						</span>
					</p>
				</div>
			)
		}else if(process.env.REACT_APP_AEONPAY === "true" && sharedInfo.aeonPayFlg === "1" && props.otbErr === true){ //AEONPAY有効＆連携ON＆OTB取得失敗
			console.log("AEONPAY有効 ＆ 連携ON ＆ OTB取得失敗");
			return (
				<div className={`${styles.aeonPayBox}`}>
					<p className={styles.aeonPayBox_txt}>
						<span>
							<span className={styles.aeonPayBox_txt_icn}>
								<img src="/images/img_aeonpay01.png" alt="" width="32" height="22" />
							</span>
							{/* AEON Payで支払う */}
							AEON Payでお支払いの方はこちら
						</span>
					</p>
					<button className={`commonBtn commonBtn02 ${styles.aeonPayBtn}`} onClick={goAEONPay}><span>AEON Pay</span></button>
				</div>
			)
		}
	})()
}

{
	(() => {
		console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
		console.log("props.otbErr: " + props.otbErr);
		console.log("memberCodeVerCheck: " + memberCodeVerCheck);
		if(process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === false){ //会員バーコード連携 OTB取得失敗：STEP1 v5.4.0未満
			console.log("会員バーコード連携 OTB取得失敗：STEP1");
			return (
				<div className={`${styles.menberCodeBox}`}>
				<p className={`${styles.menberCodeBox_txt}`}>
					<span>
						<span className={`${styles.menberCodeBox_txt_icn}`}>
							<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
						</span>
						会員コードを登録する方はこちら
					</span>
				</p>
				<p className={`${styles.payCompBox_txt}`}>レジゴーを閉じてから<br/>iAEONで会員コードを表示してください</p>
				<button className={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>レジゴーを閉じる</span></button>
				</div>
			)
		} else if(process.env.REACT_APP_IAEON_FLG === "true" && props.otbErr === true && memberCodeVerCheck === true){ //会員バーコード連携 OTB取得失敗：STEP2 v5.4.0以上
			console.log("会員バーコード連携 OTB取得失敗：STEP2");
			return (
				<div className={`${styles.menberCodeBox}`}>
					<p className={`${styles.menberCodeBox_txt}`}>
						<span>
							<span className={`${styles.menberCodeBox_txt_icn}`}>
								<img src="/images/img_membercode01.png" alt="" width="32" height="22" />
							</span>
							会員コードを登録する方はこちら
						</span>
					</p>
					<button class={`commonBtn commonBtn02 ${styles.menberCodeBtn}`} onClick={goMemberCode}><span>会員コードを表示する</span></button>
				</div>
			)
		}
	})()
}

	<div className={`${styles.payCompBox} ${styles.is_last}`}>
		<p className={styles.payCompBox_txt}>お支払いが済みましたら<br/>下のボタンをタップしてください</p>
		<button className={`commonBtn commonBtn01 ${styles.payCompBox_btn}`} onClick={() => {onSettleCheck();props.setSoundState("se08_se");}}><span>お支払い完了</span></button>
	</div>

	</div>

	</>
)

}
